import { FieldErrors, UseFormRegister } from 'react-hook-form';
import { POSITIVE_NUMBER_REGEX } from '../../../../utils/regex';

type RiskAppetiteItemProps = {
  label: string;
  type?: 'summary' | 'modal';
  showColumnLabels?: boolean;
  highlightFirst?: boolean;
  highlightSecond?: boolean;
  register: UseFormRegister<any>;
  errors: FieldErrors;
};

type InputFieldProps = {
  name: string;
  label: string;
  isDisabled: boolean;
  isHighlighted: boolean;
  isError: boolean;
  errorType: string | undefined;
  errorMessage: string;
  register: UseFormRegister<any>;
  pattern: RegExp;
  showColumnLabels: boolean;
  columnLabel: string;
  type?: 'summary' | 'modal';
};

const InputField = ({
  name,
  isDisabled,
  isHighlighted,
  isError,
  errorType,
  errorMessage,
  register,
  pattern,
  showColumnLabels,
  columnLabel,
  type,
}: InputFieldProps) => {
  const inputClasses = [
    'w-full md:w-[100px] lg:w-[115px] 2xl:min-w-[180px] h-7 border rounded-md text-primary-100 text-center focus:shadow-none focus:ring-0',
    type === 'modal' && isHighlighted ? 'bg-blue text-white border-none' : '',
    isError ? 'border-danger focus:border-danger bg-danger/5' : '',
  ].join(' ');

  return (
    <div className="relative h-9">
      <input
        disabled={isDisabled}
        type="text"
        className={inputClasses}
        readOnly={type === 'summary'}
        {...register(name, {
          required: !isDisabled,
          pattern,
        })}
      />
      {isError && (
        <span className="flex items-center justify-end text-right text-danger text-sm font-normal  ">
          {errorType === 'required' ? 'Required' : errorMessage}
        </span>
      )}
      {showColumnLabels && (
        <span className="absolute right-0 -top-5 italic font-medium text-sm text-secondary-100">
          {columnLabel}
        </span>
      )}
    </div>
  );
};

const RiskAppetiteItem = ({
  label,
  type = 'summary',
  showColumnLabels = false,
  highlightFirst = false,
  highlightSecond = false,
  register,
  errors,
}: RiskAppetiteItemProps) => {
  const fieldNamePrefix = label.replace(/\s+/g, '');

  return (
    <div className="flex items-center justify-between w-full gap-2">
      <label className="text-primary-100 font-semibold flex-1  ">{label}</label>
      <div className="flex items-center gap-2">
        <InputField
          name={`${fieldNamePrefix}Mto`}
          label={label}
          isDisabled={highlightFirst}
          isHighlighted={highlightFirst && type === 'modal'}
          isError={!!errors?.[`${fieldNamePrefix}Mto`]}
          errorType={
            errors?.[`${fieldNamePrefix}Mto`]?.type as string | undefined
          }
          errorMessage="Invalid number"
          register={register}
          pattern={POSITIVE_NUMBER_REGEX}
          showColumnLabels={showColumnLabels}
          columnLabel="months"
          type={type}
        />
        <InputField
          name={`${fieldNamePrefix}Rto`}
          label={label}
          isDisabled={highlightSecond}
          isHighlighted={highlightSecond && type === 'modal'}
          isError={!!errors?.[`${fieldNamePrefix}Rto`]}
          errorType={
            errors?.[`${fieldNamePrefix}Rto`]?.type as string | undefined
          }
          errorMessage="Invalid number"
          register={register}
          pattern={POSITIVE_NUMBER_REGEX}
          showColumnLabels={showColumnLabels}
          columnLabel="revenue"
          type={type}
        />
      </div>
    </div>
  );
};

export default RiskAppetiteItem;
